<template>
  <fairmat-target-market
    v-if="payload !== null"
    class="mt-3"
    :is-banking-env="false"
    :intervals="timeHorizonIntervalsList"
    :standard="payload"
    :lang="$i18n.locale"
    :hide-retail-investor-age-range="isInvestmentCertificates"
    :hide-limited-capital-loss-level="isInvestmentCertificates"
    @option-clicked="onOptionClicked"
  ></fairmat-target-market>
  <div v-else class="h5 font-weight-bold text-center mt-5">N/A</div>
</template>

<script>
// "Target market" (TargetMarket). TargetMarketSectionBuilder exposes TargetMarketIndicatorsDto
// (Product.TargetMarket, asset-class-agnostic), so this is a pure passthrough to the shared
// `@fairmat/vue-components` FairmatTargetMarket.vue — no adapter needed.
//
// `hideRetailInvestorAgeRange`/`hideLimitedCapitalLossLevel` are props of that component (since
// @fairmat/vue-components@1.98.0) — IC hides
// "Età Cliente Retail Minima/Massima"/"Livello di Perdita di Capitale", IBIPs shows them.
// Asset class is read the same way every other asset-class-aware
// view in this repo does (`$store.getters.getSelectedAssetClass`, e.g. `ResultsTable.vue`,
// `Search.vue`).
//
// `intervals` — the `timeHorizonIntervalsList` computed (with a defensive deep-clone): the buckets themselves are global, product-independent
// configuration loaded once at app bootstrap (`main.js`'s `getTimeHorizonIntervals` dispatch, driven by
// `user/info`), not part of this page's own response — every page reads the same root-level Vuex
// module, so no new fetch is needed here.
//
// `@option-clicked` (jumps to a specific investment option's own Target Market tab) — wired to ProductDetails.vue's own
// selectInvestmentOptionByName(name) via the detailPage inject (see that method's own comment for why
// the by-NAME lookup lives there and not here). IC has no MOP investment options for this event to
// ever fire meaningfully against (its per-option breakdowns collapse to a single unnamed entry), so
// this is a no-op there in practice, not a IC-specific branch.
//
// `canViewTargetMarket` permission gate: the entire "Target market" tab is hidden for a user
// without it. The backend catalog's
// `TargetMarket` row (`configs_detail_sections`, both `Ibips`/`InvestmentCertificates`) has
// `required_permission = NULL` — unlike `AdditionalInfo`'s `AdditionalInfoAccess` gate, this
// permission is NOT enforced server-side, so the FE check is a real access-control
// gate. It is applied at the tab level in ProductDetails.vue (excluded
// from `productTabs` for a user without it), not inside this component — permissions are a
// page-level concern, same as the `investmentOptionsTab`/`productTabs` filtering there.
export default {
  name: 'target-market-section',
  inject: ['detailPage'],
  props: {
    payload: { type: Object, default: null },
  },
  computed: {
    isInvestmentCertificates() {
      return this.$store.getters.getSelectedAssetClass === 'investment-certificates'
    },
    timeHorizonIntervalsList() {
      return this.$store.getters.getTimeHorizonIntervalsList.map((el) => JSON.parse(JSON.stringify(el)))
    },
  },
  methods: {
    onOptionClicked(opt) {
      this.detailPage.selectInvestmentOptionByName(opt.name)
    },
  },
}
</script>
